module.exports = __webpack_public_path__ + "static/img/2-2.00cc83e2.png";